import React from 'react';
import { Box, Button, Grid, Paper, TextField, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Swal from 'sweetalert2';

import { getRequest, postRequest } from 'Includes/api/apicall';
import { GET_URL, POST_URL } from 'Includes/urls';

function SprintList(props) {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [form, setForm] = React.useState({ name: '', from_date: '', to_date: '' });

  const loadSprints = React.useCallback(() => {
    setLoading(true);
    getRequest(GET_URL.sprints.api, { limit: 200, pageno: 1 }, props).then((response) => {
      if (response && response.status === 200) {
        setRows(response.data?.data || []);
      }
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [props]);

  React.useEffect(() => {
    loadSprints();
  }, [loadSprints]);

  const createSprint = () => {
    if (!form.name || !form.from_date || !form.to_date) {
      Swal.fire({ icon: 'warning', title: 'Sprint name, from date and to date are required' });
      return;
    }
    postRequest(POST_URL.sprints.api, [form], props).then((response) => {
      if (response && response.status === 200) {
        Swal.fire({ icon: 'success', title: 'Sprint created', timer: 1200, showConfirmButton: false });
        setForm({ name: '', from_date: '', to_date: '' });
        loadSprints();
      }
    });
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={700}>Sprint List</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Create sprint and manage sprint date ranges.
      </Typography>
      <Paper sx={{ p: 2, borderRadius: 2, mb: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField fullWidth size="small" label="Sprint Name" value={form.name} onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))} />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField fullWidth size="small" type="date" label="From Date" InputLabelProps={{ shrink: true }} value={form.from_date} onChange={(e) => setForm((prev) => ({ ...prev, from_date: e.target.value }))} />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField fullWidth size="small" type="date" label="To Date" InputLabelProps={{ shrink: true }} value={form.to_date} onChange={(e) => setForm((prev) => ({ ...prev, to_date: e.target.value }))} />
          </Grid>
          <Grid item xs={12} md={2}>
            <Button fullWidth variant="contained" onClick={createSprint}>Create</Button>
          </Grid>
        </Grid>
      </Paper>
      <Paper sx={{ p: 2, borderRadius: 2 }}>
        <DataGrid
          autoHeight
          rows={rows}
          columns={[
            { field: 'name', headerName: 'Sprint Name', minWidth: 220, flex: 1 },
            { field: 'from_date', headerName: 'From Date', minWidth: 140, flex: 0.7 },
            { field: 'to_date', headerName: 'To Date', minWidth: 140, flex: 0.7 },
          ]}
          loading={loading}
          hideFooter
          disableRowSelectionOnClick
        />
      </Paper>
    </Box>
  );
}

export default SprintList;

